var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnOnboardingPhotographerOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_onboarding_photographer_on"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.8349 27.6459C28.6605 27.6459 25.978 30.3283 25.978 33.5028C25.978 36.6772 28.6605 39.3597 31.8349 39.3597C35.0094 39.3597 37.6919 36.6772 37.6919 33.5028C37.6919 30.3283 35.0094 27.6459 31.8349 27.6459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.4523 19.8364H43.4661C42.7858 19.8364 42.1334 19.5662 41.6524 19.0851L37.1187 14.5515C36.7527 14.1854 36.2562 13.9796 35.7385 13.9795H27.9292C27.4115 13.9796 26.915 14.1854 26.549 14.5515L22.0153 19.0851C21.5343 19.5662 20.8819 19.8364 20.2016 19.8364H16.2154C14.062 19.8364 12.3108 21.5876 12.3108 23.741V45.2164C12.3108 47.3698 14.062 49.121 16.2154 49.121H47.4523C49.6057 49.121 51.3569 47.3698 51.3569 45.2164V23.741C51.3569 21.5876 49.6057 19.8364 47.4523 19.8364ZM31.8338 43.2641C26.5431 43.2641 22.0723 38.7933 22.0723 33.5025C22.0723 28.2118 26.5431 23.741 31.8338 23.741C37.1246 23.741 41.5954 28.2118 41.5954 33.5025C41.5954 38.7933 37.1246 43.2641 31.8338 43.2641Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnOnboardingPhotographerOn);
export default __webpack_public_path__ + "static/media/icn_onboarding_photographer_on.313aaf95c9ebc8900ec719fcd954def4.svg";
export { ForwardRef as ReactComponent };